module.exports = __webpack_public_path__ + "static/media/document.9c2952d0.svg";